<template>
  <div :class="$style.act">
    <h1 :class="$style.actTitle">{{ actInfo.actTitle }}</h1>
    <!-- banner -->
    <img :class="$style.banner" :src="actInfo.banner" alt="" />
    <div :class="$style.gameInfo" v-if="actInfo.appName">
      <img :src="actInfo.logo" alt="" />
      <div :class="$style.inner">
        <h4>{{ actInfo.appName }}</h4>
        <p>
          <span>{{ `${actInfo.version}·` }}</span>
          <span>{{ `${actInfo.categoryName}` }}</span>
        <div :class="$style.tags">
          <div v-for="(item, index) in actInfo.tags" :key="index">
            <span :style="{ backgroundColor: item.labelInfo, opacity: '0.2' }"></span>
            <span :style="{ color: item.labelInfo }">{{ item.labelName }}</span>
          </div>
        </div>
      </div>
      <div :class="$style.download" @click="download(1)">下载</div>
    </div>
    <!-- 活动详情 -->
    <div :class="$style.info">
      <img src="//static.hzwxbz3.cn/Lianyun/font_end/gameBox/act-title.png" alt="">
      <pre v-html="actInfo.context"></pre>
    </div>
    <!-- 分享 -->
    <div :class="$style.share" v-show="shareShow" @touchmove.prevent>
      <img :src="share" alt="" />
      <img :src="close" @click="shareShow = false" alt="" />
    </div>
    <div :class="$style.download1" @click="downloadBox">下载盒子，查看更多精彩内容</div>
  </div>
</template>

<script>
import { wxActInfo, gameInfo, burnPoint } from '@/apis/heziShare.js';
import { pageLoseTips } from "@/libs/utils";

export default {
  data() {
    return {
      icon: '//static.hzwxbz3.cn/Lianyun/font_end/gameBox/download_icon.png',
      share: '//static.hzwxbz3.cn/Lianyun/font_end/gameBox/share.png',
      close: '//static.hzwxbz3.cn/Lianyun/font_end/gameBox/close.png',
      actInfo: {},
      shareShow: false,
      isWX: false
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      const ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      this.isWX = ua.match(/MicroMessenger/i) == 'micromessenger';
      const { actId } = this.$route.query;
      if (!actId || isNaN(actId)) {
        pageLoseTips(this.$toast);
        return
      }
      const r = await wxActInfo({ actId: actId });
      this.actInfo = r.data;
      burnPoint({
        event: 'active_share_open',
        appid: '200010676',
        event_field: JSON.stringify({
          active_link: `${location.origin}${location.pathname}?actId=${this.$route.query.actId}`,
          active_id: this.$route.query.actId,
          active_name: this.actInfo.actTitle
        })
      })
    },
    download(type) {
      if (this.isWX) {
        this.shareShow = true;
        return;
      }
      window.open(type == 1 ? this.actInfo.downloadUrl : this.actInfo.appUrl, '_blank');
    },
    downloadBox() {
      window.open("http://pop.ad.wxbz123.cn/Planlist/ad?id=62b056dec255064d8f5b7cf2", '_blank');
      const { actId } = this.$route.query;
      if (!actId || isNaN(actId)) {
        return
      }
      burnPoint({
        event: 'active_share_download',
        appid: '200010676',
        event_field: JSON.stringify({
          active_link: `${location.origin}${location.pathname}?actId=${this.$route.query.actId}`,
          active_id: this.$route.query.actId,
          active_name: this.actInfo.actTitle
        })
      })
    }
  }
};
</script>

<style lang="scss" module>
.act {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  position: relative;
  padding-bottom: 100px;
  .actTitle {
    position: absolute;
    top: 15px;
    font-size: 18.75px;
    font-weight: 700;
    text-align: center;
    width: 100%;
    color: #FFFFFF;
  }

  .banner {
    width: 100%;
    height: 208px;
    object-fit: cover;
  }

  .gameInfo {
    width: calc(100% - 20px);
    margin: 7px 10px;
    padding: 10px 5px 5px 5px;
    background-color: #ffffff;
    border-radius: 6.94px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    > img {
      width: 69px;
      height: 69px;
      display: inline-block;
      margin-right: 12px;
    }

    .inner {
      width: 140px;
      height: 100%;
      > h4 {
        font-size: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 500;
        text-align: left;
        color: #333333;
        line-height: 26px;
        margin-bottom: 9px;
      }
      > p {
        width: 100%;
        font-size: 11px;
        font-family: SourceHanSansCN, SourceHanSansCN-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 12px;
      }
      .tags {
        width: 100%;
        height: 14px;
        display: flex;
        margin-top: 6px;
        > div {
          display: inline-block;
          padding: 2px 6px;
          line-height: 12px;
          box-sizing: border-box;
          border-radius: 2px;
          text-align: center;
          font-size: 9px;
          margin-right: 4px;
          position: relative;
          > span:nth-child(1) {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 2px;
            // z-index: -1;
          }
        }
      }
    }

    .download {
      width: 59.03px;
      height: 24.31px;
      border: 1PX solid #fc5f5e;
      border-radius: 12.85px;
      color: #FC5F5E;
      font-size: 12.5px;
      text-align: center;
      line-height: 24px;
      margin-left: 40px;
    }
  }

  .info {
    width: 360px;
    min-height: 200px;
    background: #FFFFFF;
    border-radius: 8px;
    margin: 5px auto 10px auto;
    padding: 13px 10px 10px 10px;
    > img {
      width: 100%;
    }
    > pre {
      width: 100%;
      font-size: 13px;
      font-family: SourceHanSansCN, SourceHanSansCN-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #999999;
      line-height: 21px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
  .icon {
    width: 70px;
    position: fixed;
    right: 10px;
    bottom: 30px;
  }
  .share {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10;
    > img:nth-child(1) {
      width: 100%;
    }
    > img:nth-child(2) {
      width: 20px;
      display: block;
      margin: 30px auto;
    }
  }
  .download1 {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 10px;
    width: 300px;
    height: 40px;
    font-size: 15px;
    margin: auto;
    border-radius: 40px;
    background: #fc5f5e;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
  }
}
</style>
